export default {
  methods: {
    defineIDGToString(num) {
      let number = num.toString();
      number = number.slice(-6);
      return number;
    },
    defineIDGShort(num) {
      let number = num;
      number = number.slice(-6);
      return number;
    },
    defineIDGShortLastThree(num) {
      let number = num.toString();
      number = number.slice(-3);
      return number;
    },
    defineIDGShortLastSix(num) {
      let number = null;
      if (num === null || num === undefined) {
        number = "NA";
      } else {
        number = num.toString();
        number = number.slice(-6);
      }
      return number;
    },
    defineStringLastSix(string) {
      let word = null;
      if (string === null || string === undefined) {
        word = "NA";
      } else {
        word = string.substr(string.length - 6);
      }
      return word;
    },
    addRiskValues(list) {
      let n = 0;
      for (let i = 0; i < list.length; i++) {
        n = n + list[i].char.calc;
      }
      return n;
    }
  }
};
